<script setup lang='ts'>

</script>

<template>
    <div>
        <slot name="title" />
    </div>

    <slot name="controls" />
    <hr>
    <slot name="edit" />
    <slot name="details" />
</template>

<style scoped>

</style>
